import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfig } from '@app/core/app.config';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { OrganizationNameReset } from '@app/shared/store/reducers/organization-name.actions';
import { ExtraValidators } from '@app/shared/validators/extra-validators.module';
import { Store } from '@ngrx/store';
import ApiService from '@services/api.service';

@Component({
  templateUrl: './duplicate-organization-modal.component.html',
  standalone: false
})
export class DuplicateOrganizationModalComponent implements OnInit, OnDestroy {
  private readonly apiService = inject(ApiService);
  private readonly fb = inject(FormBuilder);
  private readonly store = inject<Store<any>>(Store);
  protected readonly appConfig = inject(AppConfig);
  protected readonly data = inject(MAT_DIALOG_DATA);

  public organizationForm: FormGroup<{ name: FormControl<string>, withData: FormControl<boolean> }>;

  public ngOnInit(): void {
    this.organizationForm = this.fb.group({
      name: this.fb.control('', Validators.compose([
        Validators.required,
        Validators.maxLength(this.appConfig.NAME_MAX_LENGTH)
      ])),
      withData: this.fb.control(true, Validators.compose([Validators.required]))
    });
    this.organizationForm.controls.name.setAsyncValidators(
      ExtraValidators.isValueTaken(this.apiService, EntityTypeEnum.ORGANIZATION, 'name', '', {}, {
        store: this.store,
        fieldName: 'organizationName'
      })
    );
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new OrganizationNameReset({currentValue: '', originalValue: ''}));
  }

  public getGeneratedObject(): any {
    return {
      organizationName: this.organizationForm.controls.name.value,
      duplicateData: this.organizationForm.controls.withData.value ?? false
    };
  }
}
